var React = require('react');

function LetterLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M139.769,1.945L140.5,0h64.984v110.178l-36.06,117.438h36.06v85.553H144.01L125.604,373.9H0L139.769,1.945z M139.56,307.168\r\n\th65.924v-73.553h-44.176L205.484,89.95V6h-60.828L8.664,367.9h112.488L139.56,307.168z"}));
}

LetterLeft.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"205.484px","height":"373.9px","viewBox":"0 0 205.484 373.9","enableBackground":"new 0 0 205.484 373.9","xmlSpace":"preserve"};

module.exports = LetterLeft;

LetterLeft.default = LetterLeft;
